import { Collapse, Button, Row, Col } from "antd";
import { useState } from "react";

const { Panel } = Collapse;

const FAQSection = () => {
  // Initial FAQ data (first 10 items)
  const initialFAQ = [
    // {
    //   question: "1. Канвас хэд вэ?",
    //   answer: "",
    // },
    {
      question: "2. Өөрсдөө зургаа яаж дардаг вэ?",
      answer:
        "Тусгайлан бэлдсэн фонн камер гэрэл байгаа Дэлгэцэн дээр өөрийгөө харж удирдлагаар зургаа дардаг.",
    },
    {
      question: "3. Цаг хэрхэн захиалах вэ?",
      answer:
        "Та <a href='https://booking.picshot.online' target='_blank'>энд дарж</a> орж Хөрөг зургын цаг захиалах боломжтой.<br/>Та <a href='https://booking.picshot.online' target='_blank'>энд дарж</a> орж Энгийн зургын цаг захиалах боломжтой.",
    },
    {
      question: "4. Бүх зураг файлаар авч болох уу?",
      answer:
        "Бүх зураг файлуудыг WeTransfer-ээр майл хаягруу нь явуулж өгнө. Хэрэв та хүсвэл хэвлэж авах үйлчилгээ ч санал болгож байна.",
    },
  ];

  const [faqData, setFaqData] = useState(initialFAQ); // Initial FAQ state
  const [visibleCount, setVisibleCount] = useState(5); // Number of visible FAQs
  const [loading, setLoading] = useState(false); // Button loading state

  const loadMoreFAQ = () => {
    setLoading(true);

    const moreFAQ = [
      {
        question: "5. Хүүхдийн зураг авалт ямар хугацаанд дуусах вэ?",
        answer:
          "Хүүхдийн зураг авалт нь 30 минут орчим үргэлжилдэг бөгөөд эхний удаагийн цуглуулга нь маш хурдан авах боломжтой.",
      },
      {
        question: "6. Студийн байрлал хаана байдаг вэ?",
        answer: "Манай студи Улаанбаатар хотын төвд байрладаг.",
      },
      {
        question: "7. Хэрхэн төлбөр төлөх вэ?",
        answer:
          "Төлбөрийг карт, бэлэн мөнгө, эсвэл онлайн төлбөрийн системээр хийх боломжтой.",
      },
      {
        question: "8. Дижитал файлуудыг хэрхэн авах вэ?",
        answer:
          "Та бүх зургийг цахим шуудан эсвэл хариуцсан апп ашиглан авах боломжтой.",
      },
      {
        question: "9. Цаг тохируулахдаа ямар мэдээлэл өгөх вэ?",
        answer:
          "Та зөвхөн нэр, утасны дугаар, болон хүссэн цагийнхаа мэдээллийг оруулах шаардлагатай.",
      },
      {
        question: "10. Студийн зураг авах үйлчилгээний үнэ хэд вэ?",
        answer:
          "Үнүүд манай вэбсайт дээр эсвэл утсаар холбогдож лавлах боломжтой.",
      },
      {
        question: "11. Студийн үйлчилгээнд юу багтдаг вэ?",
        answer:
          "Манай студи нь гэрэл зургийн зөвлөмж, хувцас, хэрэгсэл зэрэг олон төрлийн үйлчилгээг санал болгодог.",
      },
      {
        question: "12. Сессийн явцад би юу авах вэ?",
        answer: "Та зураг, хөтөч болон бусад хэрэгсэл авах болно.",
      },
      {
        question: "13. Студийн үйлчилгээнд ямар нэмэлт зүйлс байдаг вэ?",
        answer:
          "Хүүхдийн зураг авалт болон гэр бүлийн зураг авах нэмэлт үйлчилгээ байна.",
      },
      {
        question: "14. Студийн зураг авалтын төрөл гэж юу вэ?",
        answer:
          "Энгийн, зурагт портрет болон хүүхдийн зураг авалт зэргийг санал болгодог.",
      },
      {
        question: "15. Онлайн захиалга хийх боломжтой юу?",
        answer:
          "Тиймээ, та онлайн захиалга хийх боломжтой бөгөөд энэ нь хялбар бөгөөд хурдацтай.",
      },
    ];

    setFaqData((prevData) => [...prevData, ...moreFAQ]);
    setVisibleCount(visibleCount + 5); // Increase the number of visible FAQs
    setLoading(false); // Re-enable the button after loading
  };

  const isButtonDisabled = faqData.length >= 20; // Disable the button if all FAQs are loaded

  return (
    <div style={{ maxWidth: "100%", margin: "0px auto", textAlign: "left" }}>
      <Row justify="center">
        <Col xs={24} sm={18} md={12} lg={10}>
          <h1 style={{ textAlign: "center", marginBottom: "10px" }}>
            <span style={{ color: "black" }}>📌 Frequently asked question</span>
          </h1>

          <Collapse accordion>
            {faqData.slice(0, visibleCount).map((item, index) => (
              <Panel header={`📌 ${item.question}`} key={index}>
                {/* <p>📌 {item.answer}</p> */}
                <p dangerouslySetInnerHTML={{ __html: item.answer }} />
              </Panel>
            ))}
          </Collapse>

          {/* More FAQ Button */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              type="primary"
              onClick={loadMoreFAQ}
              loading={loading}
              disabled={true}
            >
              {isButtonDisabled ? "Баярлалаа" : "Дэлгэрэнгүй"}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default FAQSection;
